export function normalizeWerkplanScope(scope) {
  if (typeof scope === "boolean") {
    return { includeNewSheets: true, includeRestSheets: scope };
  }

  const value = scope || {};
  return {
    includeNewSheets: value.includeNewSheets !== false,
    includeRestSheets: value.includeRestSheets !== false,
  };
}

function sheetMatchesScope(sheet, scope) {
  const { includeNewSheets, includeRestSheets } = normalizeWerkplanScope(scope);
  if (sheet.source === "rest") return includeRestSheets;
  return includeNewSheets;
}

export function getWerkplanSheets(layout, scope = true) {
  return (layout?.sheets || []).filter((sheet) => sheetMatchesScope(sheet, scope));
}

export function getWerkplanPlateNumbers(layout, panelId, scope = true) {
  const plates = [];
  (layout?.sheets || []).forEach((sheet) => {
    if (!sheetMatchesScope(sheet, scope)) return;
    if (sheet.placements.some((placement) => placement.panelId === panelId)) {
      plates.push(sheet.index + 1);
    }
  });
  return plates.join(", ");
}

export function filterWerkplanRows(rows, layout, scope = true) {
  const { includeNewSheets, includeRestSheets } = normalizeWerkplanScope(scope);
  if (includeNewSheets && includeRestSheets) return rows;
  return rows.filter((row) => getWerkplanPlateNumbers(layout, row.id, scope).length > 0);
}
